import { createApp } from "vue";
import ElementPlus from "element-plus";
import "core-js/stable";
import "element-plus/dist/index.css";
import "./utils/flexible.js"; // 引入响应式适配脚本
import "./styles/index.less";
import router from "./router";
import App from "./App.vue";
const app = createApp(App);
app.use(ElementPlus);
app.use(router);
app.mount("#app");
